// /* eslint-disable react/prop-types */
// // Argon Dashboard 2 MUI components
// import ArgonBox from "components/ArgonBox";
// import ArgonTypography from "components/ArgonTypography";
// import ArgonAvatar from "components/ArgonAvatar";
// import ArgonBadge from "components/ArgonBadge";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';

// // Images
// import team2 from "assets/images/team-2.jpg";
// import team3 from "assets/images/team-3.jpg";
// import team4 from "assets/images/team-4.jpg";
// import { Button } from "@mui/material";
// import { Link } from "react-router-dom";
// import ArgonButton from "components/ArgonButton";

// function Author({ image, name, email }) {

//   return (
//     <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
//       <ArgonBox mr={2}>
//         <ArgonAvatar src={image} alt={name} size="sm" variant="rounded"/>
//       </ArgonBox>
//       <ArgonBox display="flex" flexDirection="column">
//         <ArgonTypography textTransform="none" variant="button" fontWeight="medium">
//           {name}
//         </ArgonTypography>
//         <ArgonTypography variant="caption" color="secondary">
//           {email}
//         </ArgonTypography>
//       </ArgonBox>
//     </ArgonBox>
//   );
// }

// const tutorTableData = (handleDeleteClick) => ({
//   columns: [

//     {name:"sno",align:"center"},
//     {name:"profile",align:"left"},
//     {name:"MobileNo", align:"left"},
//     {name:"JoiningDate",align:"left"},
//     {name:"Area/city",align:"left"},
//     {name:"status",align:"left"},
//     {name:"action",align:"center"}
//   ],

//   rows: [
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{1}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       "Area/city":<ArgonTypography variant="caption" fontWeight="medium" color="text">{"MP Nagar Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={0}>
//            {/* View Icon */}
//             <ArgonButton variant="text"  size="large" component={Link} to="/tutors/profile" sx={{minWidth:"12px",p:0}} >
//               <VisibilityIcon color="primary"/>
//             </ArgonButton>
//             {/* Delete icon */}
//            <ArgonButton variant="text"  size="large" sx={{minWidth:"32px",p:0}}
//            onClick={() =>handleDeleteClick()} >
//              <DeleteIcon color="error"/>
//            </ArgonButton>

//          </ArgonBox>
//        ),
//     },
//   ],
// })

// export default tutorTableData;

/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import ArgonButton from "components/ArgonButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link, useNavigate } from "react-router-dom";
import axios, { baseURL } from "utils/api";

// Profile cell
function Author({ image, name, email, id }) {
  const navigate = useNavigate();

  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="rounded" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography
          textTransform="none"
          variant="button"
          fontWeight="medium"
          onClick={() => navigate(`/tutors/profile/${id}`)}
          sx={{
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": {
              color: "#1976d2",
              textDecoration: "underline",
            },
          }}
        >
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

// Static columns
const columns = [
  { name: "sno", align: "center" },
  { name: "profile", align: "left" },
  { name: "MobileNo", align: "left" },
  { name: "Joining Date", align: "left" },
  { name: "Area/city", align: "left" },
  { name: "status", align: "left" },
  { name: "action", align: "center" },
];

// Hook for fetching tutors
const useTutorData = (handleDeleteClick, approvalStatus) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState({
    All: 0,
    PENDING: 0,
    APPROVED: 0,
    REJECTED: 0,
    DEACTIVATED: 0,
  });
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const refetchTutors = () => {
    setRefetchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Fetch counts for all statuses
        const statuses = ["All", "PENDING", "APPROVED", "REJECTED", "DEACTIVATED"];
        const countPromises = statuses.map(async (status) => {
          let url = `${baseURL}/tutor`;
          if (status !== "All") {
            url += `?approvalStatus=${status}`;
          }
          const response = await axios.get(url, {
            params: { page: 1, limit: 1 },
          });
          return { status, count: response.data.data.pagination?.totalTutors || 0 };
        });

        const countResults = await Promise.all(countPromises);
        const newCounts = {};
        countResults.forEach(({ status, count }) => {
          newCounts[status] = count;
        });
        setCounts(newCounts);

        // Fetch data for current approvalStatus with maximum allowed limit
        let url = `${baseURL}/tutor`;
        const params = { limit: 100, page: 1 }; // Max limit allowed by backend
        if (approvalStatus && approvalStatus !== "All") {
          params.approvalStatus = approvalStatus;
        }
        const res = await axios.get(url, { params });
        console.log("Tutors API Response:", res.data);
        console.log("Total Tutors Fetched:", res.data.data.tutors?.length);

        const data = res.data.data.tutors || [];

        const formattedRows = data.map((item, index) => ({
          sno: (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {index + 1}
            </ArgonTypography>
          ),
          profile: (
            <Author
              image={item.profileImage}
              name={item.fullName}
              email={item.email}
              id={item.id}
            />
          ),
          MobileNo: (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {item.phone || "N/A"}
            </ArgonTypography>
          ),
          "Joining Date": (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {item.joiningDate ? new Date(item.joiningDate).toLocaleDateString() : "N/A"}
            </ArgonTypography>
          ),
          "Area/city": (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {(() => {
                let shortAddress = "";

                // First, try to extract from item.address which might have structured 'Area:' and 'City:'
                const addressStr = item.address || "";
                const areaMatch = addressStr.match(/Area:\s*(.*?)(?=,\s*[a-zA-Z\/]+:|$)/i);
                const cityMatch = addressStr.match(/City:\s*(.*?)(?=,\s*[a-zA-Z\/]+:|$)/i);

                const area = areaMatch ? areaMatch[1].trim() : "";
                const city = cityMatch ? cityMatch[1].trim() : "";

                if (area && city) {
                  shortAddress = `${area}, ${city}`;
                } else if (area || city) {
                  shortAddress = area || city;
                } else {
                  // Fallback for flat strings, preferring item.address if it's valid
                  const fallbackAddress =
                    item.address && item.address !== "-" && item.address.length > 2
                      ? item.address
                      : item.permanentAddress &&
                        item.permanentAddress !== "-" &&
                        item.permanentAddress.length > 2
                      ? item.permanentAddress
                      : item.locationPreference?.[0]?.city || "N/A";

                  if (fallbackAddress === "N/A" || fallbackAddress === "-") return "N/A";

                  const parts = fallbackAddress.split(",").map((p) => p.trim());
                  shortAddress = parts.slice(0, 2).join(", ");
                }

                // Limit to 30 characters
                return shortAddress.length > 30
                  ? shortAddress.substring(0, 30) + "..."
                  : shortAddress;
              })()}
            </ArgonTypography>
          ),
          status: (
            <ArgonBadge
              variant="gradient"
              badgeContent={item.active === false ? "DEACTIVATED" : item.approvalStatus}
              color={
                item.active === false
                  ? "error"
                  : item.approvalStatus === "APPROVED"
                  ? "success"
                  : item.approvalStatus === "PENDING"
                  ? "warning"
                  : item.approvalStatus === "REJECTED"
                  ? "error"
                  : "secondary"
              }
              size="xs"
              container
            />
          ),
          action: (
            <ArgonBox display="flex" alignItems="center" gap={0}>
              {/* View */}
              <ArgonButton
                variant="text"
                size="large"
                component={Link}
                to={`/tutors/profile/${item.id}`}
                sx={{ minWidth: "12px", p: 0 }}
              >
                <VisibilityIcon color="primary" />
              </ArgonButton>

              {/* Delete */}
              <ArgonButton
                variant="text"
                size="large"
                sx={{ minWidth: "32px", p: 0 }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log("Delete clicked for tutor ID:", item.id);
                  handleDeleteClick(item.id);
                }}
              >
                <DeleteIcon color="error" />
              </ArgonButton>
            </ArgonBox>
          ),
        }));

        setRows(formattedRows);
      } catch (err) {
        console.error("❌ Error fetching tutors:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [approvalStatus, refetchTrigger]);

  return {
    columns,
    rows,
    counts,
    refetchTutors,
    loading,
  };
};

export default useTutorData;
